export default __webpack_public_path__ + "locales/bg/Translations.json?hash=0cad35bd302ba250546efc31cea5a887";